import React, { ReactNode, Suspense } from "react";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { WorkflowCommandsProvider } from "@src/contexts/WorkflowCommandsProvider";

import store, { persistor } from "../store";
import Loading from "../utils/Loading";

type AppProviderProps = {
  children: ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <Suspense fallback={<Loading centered={true} />}>
      <ReduxProvider store={store}>
        <PersistGate
          loading={<Loading centered={true} />}
          persistor={persistor}
        >
          <WorkflowCommandsProvider>{children}</WorkflowCommandsProvider>
        </PersistGate>
      </ReduxProvider>
    </Suspense>
  );
};
